/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

HistogramService.$inject = [
    '$location',
    '$log',
    'FiltersService',
    'UtilService',
];
function HistogramService(
    $location,
    $log,
    FiltersService,
    UtilService
) {
    var SCORE_RANGES = [100, 90, 75, 50];

    return {
        getHistogramStartsOpen: getHistogramStartsOpen,
        scoreFacetToHistogramData: scoreFacetToHistogramData,
        scoreCountsToHistogramData: scoreCountsToHistogramData,
        getScoreRangeCounts: getScoreRangeCounts,
        filterScoreRange: filterScoreRange
    };

    /**
     * Returns whether or not the histogram should start toggled open or not.
     *
     * @return {Boolean}
     */
    function getHistogramStartsOpen() {
        var histogramEnabled = UtilService.isFeatureEnabled("score_histogram");
        if (!histogramEnabled) {
            return false;
        }
        var siteSetting = !!UtilService.getSiteSetting('score_histogram_starts_open', true);
        var urlParam = $location.search().histogram_open;
        if (urlParam === true || urlParam === "true") {
            return true;
        } else if (urlParam === false || urlParam === "false") {
            return false;
        }
        return siteSetting;
    }

    /**
     * Extracts score histogram data from the `enervee_score` facet from a Swfitype
     * result. Returns an object with `min`, `max`, and `values`. If an error is
     * encountered, an empty object is returned.
     *
     * @param {Object} scoreFacet
     * @param {Array<Object>} scoreFacet.values
     * @param {Object} scoreFacet.values[].faceted_values A map of faceted values,
     * where the keys are the enervee_score, and the value is number of products with
     * that score.
     * @return {Object}
     */
    function scoreFacetToHistogramData(scoreFacet) {
        var facetHasValues = scoreFacet && scoreFacet.values && scoreFacet.values.length > 0;
        if (!facetHasValues || !scoreFacet.values[0].faceted_values) {
            $log.error("Problem retrieving histogram facet to initialize the histogram: " + JSON.stringify(scoreFacet, null, 2));
            return {};
        }

        scoreFacet = scoreFacet.values[0];
        return {
            values: scoreCountsToHistogramData(scoreFacet.faceted_values),
            min: scoreFacet.min_value,
            max: scoreFacet.max_value,
        };
    }


    /**
     * Initializes and formats histograms data into an array score counts which is what the histogram directive expects
     *
     * @param scoreCounts
     */
    function scoreCountsToHistogramData(scoreCounts) {
        var scoreToCount = {};
        for (var score in scoreCounts) {
            scoreToCount[parseInt(score)] = scoreCounts[score];
        }

        var histogramData = [];
        for (var s=0; s<=100; s++) {
            if (s in scoreToCount) {
                histogramData.push(scoreToCount[s]);
            } else {
                histogramData.push(0);
            }
        }

        return histogramData;
    }


    /**
     * Gets the range of the given score
     *
     * @param score
     * @returns {number}
     */
    function getScoreRange(score) {
        var scoreRange = SCORE_RANGES[0];

        for (var j in SCORE_RANGES) {
            var currentScoreRange = SCORE_RANGES[j];

            if (score < currentScoreRange) {
                scoreRange = currentScoreRange;
            }
        }
        return scoreRange;
    }

    /**
     * Gets the counts of each score range
     *
     * @param data
     * @returns {{}}
     */
    function getScoreRangeCounts(data) {

        var scoreRangeToCount = {};

        for (var i in SCORE_RANGES) {
            scoreRangeToCount[SCORE_RANGES[i]] = 0;
        }

        for (var score=0; score<=100; score++) {
            var scoreRange = getScoreRange(score);
            scoreRangeToCount[scoreRange] += data[score];
        }

        return scoreRangeToCount;
    }

    /**
     * Filters products by the given range
     *
     * @param range
     */
    function filterScoreRange(range) {

        FiltersService.filtersOutputCallbacks.push({
            filter_output: function() {
                return {
                    'enervee-score':
                        {
                            type: "range",
                            min: range.min,
                            max: range.max
                        }
                };
            },
            is_top_menu_item: false
        });

        FiltersService.filterResults(false);

    }
}

module.exports = HistogramService;
